import api from "./api";

export const getReviews = async (targetType, targetId) => {
    try {
        const response = await api.get("/api/reviews", {
            params: { targetType, targetId }
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching reviews:", error);
        return {
            averageRating: 5.0,
            totalReviews: 0,
            ratingCounts: { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 },
            reviews: []
        };
    }
};

export const submitReview = async (reviewData) => {
    try {
        const response = await api.post("/api/reviews", reviewData);
        return response.data;
    } catch (error) {
        console.error("Error submitting review:", error);
        throw error;
    }
};
